import { Component , TemplateRef, PLATFORM_ID ,Inject, OnInit} from '@angular/core';
import { CommonModule,isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { MatDialogModule } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { HttpClientModule } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs'

import {AnalysisServiceService } from '../../services/analysis-service/analysis-service.service';
import { FacadeService } from '../../services/facade.service';
import { ProyectosService } from '../../services/proyectos.service';

import { WordlistComponent } from '../../tools/wordlist/wordlist.component';

import { HttpClient } from "@angular/common/http";

@Component({
  selector: 'analysis-options',
  standalone: true,
  imports: [MatDialogModule,
    CommonModule,
    RouterOutlet,
    MatSidenavModule,
    MatExpansionModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    FormsModule,
    HttpClientModule],
  templateUrl: './analysis-options.component.html',
  styleUrl: './analysis-options.component.css'
})
export class AnalysisOptionsComponent  implements OnInit {

  private proyectoSub;

  private configChangeSubject = new Subject<any>(); // Subject para manejar debounce
  jsonValues: any = {}; // Aquí se almacenan los valores del config JSON
  isExpanded = false;//Variable para expandir cada recuadro

  dialogRef: any; // Referencia del diálogo abierto

  isScreenLarge: boolean = false;

  // Valores traidos del New Analysis al empezar un nuevo proyecto
  englishType?: string;
  analysisMode?: string;
  targetCEFR?: string;
  splitCharacter: string ;
  excludeDigits: boolean;
  useKnownWords: boolean;
  wordlistselect: any;

  isCreatingProject: boolean = false;

  private inactivityTimer: any;
  


  resetTimer() {
    clearTimeout(this.inactivityTimer);  // Limpia el temporizador existente
    if(sessionStorage.getItem("id_project")){
      this.proyectoService.updateloader(true);
    }
    this.startTimer();                   // Reinicia el temporizador
  }

  startTimer() {
    this.inactivityTimer = setTimeout(() => {
      this.onInactivity();  // Llama a la función después de 5 segundos de inactividad
      this.proyectoService.updateloader(false);
      this.proyectoService.updateloaderAnalyzing(true);
      this.proyectoService.verifyLoaderAnalyzing(true);
    }, 1750);  // 5000 ms = 5 segundos
  }

  onInactivity() {
    this.sendConfigToServer();
      if(sessionStorage.getItem("id_project")){
        this.proyectoService.updateloader(true);
      }
  }
  
  // Método para capturar el valor ingresado
  onInputChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.splitCharacter = inputElement.value;
  }

   // Método para alternar la expansión y cambiar el tamaño del cuadro de diálogo
   toggleExpand(): void {
    this.checkPrincipalDocument();
    this.isExpanded = !this.isExpanded;
    const newWidth = this.isExpanded ? '620px' : '350px';

    if (this.dialogRef) {
      this.dialogRef.updateSize(newWidth); // Actualiza el tamaño del cuadro de diálogo
    }
  }

  

  constructor(private http:HttpClient,
    public dialog: MatDialog,
    @Inject(PLATFORM_ID) private platformId: Object,
    private analysisService: AnalysisServiceService,
    private facade: FacadeService, 
    private proyectoService: ProyectosService ) {

  }

  openAnalysisOptions(analysisOptionsDialog: TemplateRef<any>): void {
    const dialogWidth = this.isExpanded ? '620px' : '350px';
    this.dialogRef = this.dialog.open(analysisOptionsDialog, {
      width: dialogWidth,
      position: { top: '120px', right: '40px' },
      panelClass: 'custom-dialog-container',
      backdropClass: 'dialog-backdrop-transparent' // Fondo oscuro para este diálogo
    });
  }


  ngOnInit() {

    

    //Para identificar el tamaño de la pantalla
    if (isPlatformBrowser(this.platformId)) {
      this.isScreenLarge = window.innerWidth > 1000;
      window.addEventListener('resize', this.onResize.bind(this));
    }

    this.checkPrincipalDocument();
    // Para traer los valores desde el New Analysis
    // Para traer los valores desde el New Analysis
    this.analysisService.currentEnglishType.subscribe(type => {
      if (type != this.englishType){
        this.englishType = type;
        // this.triggerConfigUpdate(); 
      }
    });

     this.proyectoService.creatingProject$.subscribe(state => {
        this.isCreatingProject = state;

    });

    this.proyectoService.creatingProjectAnalysis$.subscribe(state => {
        if(sessionStorage.getItem("id_project")){
          this.isCreatingProject = false;
        }else{
          this.isCreatingProject = state;
        }
        
    });

    this.analysisService.currentAnalysisMode.subscribe(mode => {
      if (mode != this.analysisMode){
        this.analysisMode = mode;
        
        // this.triggerConfigUpdate();
      } 
    });
    this.analysisService.currentTargetCEFR.subscribe(score => {
      if (score != this.targetCEFR){
        this.targetCEFR = score;
        
        // this.triggerConfigUpdate();
      }
    });
    this.analysisService.currentExcludeDigits.subscribe(value => {
      if (value != this.excludeDigits){
        this.excludeDigits = value;
       
        // this.triggerConfigUpdate(); 
      }
    });
    this.analysisService.currentUseKnownWords.subscribe(value => {
      if (value != this.useKnownWords){
        this.useKnownWords = value;
        
        // this.triggerConfigUpdate(); 
      }
    });
    this.analysisService.currentSplitCharacter.subscribe(value => {
      if (value != this.splitCharacter){
        this.splitCharacter = value;
        
        // this.triggerConfigUpdate(); 
      }
    });

    this.analysisService.currentWordlist.subscribe(value => {
      
        this.wordlistselect = value;
        
        // this.triggerConfigUpdate(); 
      
    });

    this.analysisService.wordlistCreated$.subscribe(wordlist => {
      const createdWordlist = this.normalizeWordlistResponse(wordlist);
      if (createdWordlist) {
        this.upsertWordlistInSession(createdWordlist);
        this.setWordlistOptionsFromSession();
        this.wordlistselect = createdWordlist.id;
      }
    });

      this.proyectoSub = this.proyectoService.proyecto$.subscribe(({ proyecto, firstProject }) => {
          if(proyecto){
              setTimeout(() => {
              this.wordlist();
            }, 100);
          }
        });
    

    this.proyectoService.refreshTextBox$.subscribe(() => { 
      setTimeout(() => {
        this.wordlist();
      }, 1000);
      
    });

    this.proyectoService.refreshAnalyse$.subscribe(() => { 
      setTimeout(() => {
        this.wordlist();
      }, 1000);
    });

    if(localStorage.getItem("text-inspector-django-token")){
      this.wordlist();
    }

    // this.updateJSON();
    // Suscribirse al Subject y esperar 4 segundos antes de ejecutar
    this.configChangeSubject.pipe(debounceTime(2500)).subscribe(() => {
      this.sendConfigToServer();
      if(sessionStorage.getItem("id_project")){
        this.proyectoService.updateloader(true);
      }
    });

    // Hacer la petición y obtener los nombres

  }

  ngOnDestroy() {
  if (this.proyectoSub) {
    this.proyectoSub.unsubscribe();
  }
}


public nombresListas: { id: any; nombre: string }[] = [];


  // async wordlist() {
  //   try {
      
  //     let respuesta2 = await this.facade.getAllwordlists(this.http,localStorage.getItem("text-inspector-django-token"));
  //     if(sessionStorage.getItem("id_project")){
  //       let respuesta = await this.facade.getInfoProyect(this.http,sessionStorage.getItem("id_project"));

  //       if (respuesta2 && respuesta2.length > 0) {
  //         this.nombresListas = [
  //           { id: null, nombre: "Pick a list" }, 
  //           ...respuesta2.map((list: any) => ({
  //             id: list.id,
  //             nombre: list.nombre,
  //           })),
  //         ];
  //       } else {
  //         this.nombresListas = [{ id: null, nombre: "Pick a list" }]; 
  //       }
  //       this.wordlistselect = 
  //       this.nombresListas.find((list) => list.id === respuesta.config_json.wordlist)
  //         ? respuesta.config_json.wordlist // Si el valor existe en `nombresListas`
  //         : this.nombresListas[0].id; // Usar "Pick a list" como predeterminado
  //     }else{
  //        // Verificar si hay datos y asignar los nombres e ids o agregar la opción "Pick a list"
  //     if (respuesta2 && respuesta2.length > 0) {
  //       this.nombresListas = [
  //         { id: null, nombre: "Pick a list" }, 
  //         ...respuesta2.map((list: any) => ({
  //           id: list.id,
  //           nombre: list.nombre,
  //         })),
  //       ];
  //     } else {
  //       this.nombresListas = [{ id: null, nombre: "Pick a list" }]; 
  //     }
  //     }
    
  //   } catch (error) {
  //     console.error("Error al cargar los nombres:", error);
  //     // Manejo de error: Solo la opción predeterminada
  //     this.nombresListas = [{ id: null, nombre: "Pick a list" }];
  //     this.wordlistselect = this.nombresListas[0].id; // Valor inicial "Pick a list"
  //   }
  // }

   async wordlist() {
    const projectId = sessionStorage.getItem("id_project");
    const token = localStorage.getItem("text-inspector-django-token");
    const actual = localStorage.getItem("actual");
  
    const storedWordlist = sessionStorage.getItem("data_wordlist");
    const storedAnalysisOp = sessionStorage.getItem("analysis_op");
    
  
    let parsedWordlist: any[] = [];
    let parsedAnalysisOp: any = null;
  
    // 1. Obtener y procesar wordlist del sessionStorage si existe
    if(token){
       if (storedWordlist) {
        try {
          parsedWordlist = JSON.parse(storedWordlist);
        } catch (error) {
          console.error("Error al parsear data_wordlist:", error);
          sessionStorage.removeItem("data_wordlist");
        }
      } else {
        try {
          parsedWordlist = await this.facade.getAllwordlists(this.http, token);
          sessionStorage.setItem("data_wordlist", JSON.stringify(parsedWordlist));
        } catch (error) {
          console.error("Error al obtener data_wordlist:", error);
          parsedWordlist = [];
          sessionStorage.removeItem("data_wordlist");
        }
      }
    }
   
  
    // 2. Obtener y procesar analysis_op del sessionStorage si existe y hay projectId
    if (projectId) {
      if (storedAnalysisOp) {
        try {
          parsedAnalysisOp = JSON.parse(storedAnalysisOp);
        } catch (error) {
          console.error("Error al parsear analysis_op:", error);
          sessionStorage.removeItem("analysis_op");
        }
      }
  
      if (!parsedAnalysisOp) {
        try {
          parsedAnalysisOp = await this.facade.getInfoProyect(this.http, projectId);
          sessionStorage.setItem("analysis_op", JSON.stringify(parsedAnalysisOp));
        } catch (error) {
          console.error("Error al obtener analysis_op:", error);
          parsedAnalysisOp = null;
          sessionStorage.removeItem("analysis_op");
        }
      }
    }
  
    // 3. Asignar nombresListas
    this.nombresListas = parsedWordlist.length > 0
      ? [
          { id: null, nombre: "Pick a list" },
          ...parsedWordlist.map((list: any) => ({
            id: list.id,
            nombre: list.nombre,
          })),
        ]
      : [{ id: null, nombre: "Pick a list" }];
  
    // 4. Asignar wordlist seleccionada solo si hay análisis de proyecto
    if (parsedAnalysisOp) {
      const cfg = parsedAnalysisOp.config_json;
      this.useKnownWords = cfg.useKnownWords ?? false; // Aquí actualizas
      this.excludeDigits = cfg.excludeDigits ?? false;
      this.analysisService.changeExcludeDigits(this.excludeDigits);
      this.analysisService.changeUseKnownWords(this.useKnownWords);
      
      this.wordlistselect = this.nombresListas.find(
        (list) => list.id === parsedAnalysisOp.config_json.wordlist
      )
        ? parsedAnalysisOp.config_json.wordlist
        : this.nombresListas[0].id;
    } else {
      this.wordlistselect = this.nombresListas[0].id;
    }
  }

  isProjectCreated: boolean | undefined;

  checkPrincipalDocument(){
    const projectRaw = sessionStorage.getItem("text_UID");
      if (projectRaw) {
        this.isProjectCreated = true
      }
      else{
        this.isProjectCreated = false
      }

    
  }


  onWordlistChange(event: any) {
    const selectedValue = event.target.value; // Obtén el ID seleccionado
    const selectedOption = this.nombresListas.find((lista) => String(lista.id) === selectedValue);
  
    if (selectedOption) {
      
      this.wordlistselect = selectedOption.id; 
      if(sessionStorage.getItem("id_project")){
        this.resetTimer()
      }
    } else {
      console.log("No se encontró la opción seleccionada.");
      this.wordlistselect = null;
    }
  }

    createList(){
      const dialogRef = this.dialog.open(WordlistComponent, {
        data: { 
          isEditing: false, 
        },
        backdropClass: 'dialog-backdrop-dark' 
      });
      dialogRef.afterClosed().subscribe(result => {
        const createdWordlist = this.normalizeWordlistResponse(result);
        if (createdWordlist) {
          this.upsertWordlistInSession(createdWordlist);
          this.setWordlistOptionsFromSession();
          this.wordlistselect = createdWordlist.id;
          this.analysisService.changeWordlist(createdWordlist.id);
          this.analysisService.notifyWordlistCreated(createdWordlist);

          if (sessionStorage.getItem("id_project")) {
            this.resetTimer();
          }
        }
      });
    }

  private normalizeWordlistResponse(result: any): any | null {
    if (!result || result === true) {
      return null;
    }

    const raw = result.lista ?? (result.data && !Array.isArray(result.data) ? result.data : result);
    const id = raw.id ?? raw.wordlist_id ?? raw.pk;
    const nombre = raw.nombre ?? raw.name;
    const listado = raw.listado ?? raw.wordlist ?? raw.words ?? [];

    if (id === null || id === undefined || !nombre) {
      return null;
    }

    return {
      ...raw,
      id,
      nombre,
      listado,
    };
  }

  private upsertWordlistInSession(wordlist: any): void {
    const storedWordlist = sessionStorage.getItem("data_wordlist");
    let parsedWordlist: any[] = [];

    if (storedWordlist) {
      try {
        parsedWordlist = JSON.parse(storedWordlist);
      } catch (error) {
        parsedWordlist = [];
      }
    }

    const index = parsedWordlist.findIndex((item: any) => item.id === wordlist.id);
    if (index >= 0) {
      parsedWordlist[index] = { ...parsedWordlist[index], ...wordlist };
    } else {
      parsedWordlist.push(wordlist);
      sessionStorage.setItem("WordLists", String(parsedWordlist.length));
    }

    sessionStorage.setItem("data_wordlist", JSON.stringify(parsedWordlist));
  }

  private setWordlistOptionsFromSession(): void {
    const storedWordlist = sessionStorage.getItem("data_wordlist");
    let parsedWordlist: any[] = [];

    if (storedWordlist) {
      try {
        parsedWordlist = JSON.parse(storedWordlist);
      } catch (error) {
        parsedWordlist = [];
      }
    }

    this.nombresListas = parsedWordlist.length > 0
      ? [
          { id: null, nombre: "Pick a list" },
          ...parsedWordlist.map((list: any) => ({
            id: list.id,
            nombre: list.nombre,
          })),
        ]
      : [{ id: null, nombre: "Pick a list" }];
  }
  

triggerConfigUpdate() {
  this.updateJSON(); // Actualizar JSON local
  this.configChangeSubject.next(null); // Emitir un evento al Subject para debounce
}
async sendConfigToServer() {
  this.updateJSON();
  let id_project= sessionStorage.getItem("id_project")
  const data = {
    id_project: id_project,
    config_json: this.jsonValues
  };

  // Llamar al servicio para enviar los datos al servidor
  try {
    let response = await this.facade.UpdateNameofProyect(this.http,data);
    this.proyectoService.updateData(response)
    this.proyectoService.updateEditEye(false);
    this.proyectoService.terminarEdicionErrores(this.http);
    this.proyectoService.showEditEye(false); 
    this.proyectoService.undoMarcadoMultiple(this.http);
  } catch (error) {
  //   console.error('Error al actualizar la configuración:', error);  
  } finally {
    this.proyectoService.verifyLoaderAnalyzing(false);
    setTimeout(() => {
      this.proyectoService.updateloaderAnalyzing(false);
    }, 500);
  }
  // this.facade.UpdateNameofProyect(this.http,data).then(response => {
  //   console.log('Configuración actualizada en el servidor:', response);
  //   this.proyectoService.updateData(response)
  // }).catch(error => {
  //   console.error('Error al actualizar la configuración:', error);
  // });
}

  onResize() {
    this.isScreenLarge = window.innerWidth > 1000;
  }
  
  onEnglishTypeChange(event: any) {
    this.analysisService.changeEnglishType(event.target.value);
    this.resetTimer()
    // Esperar 2 segundos antes de llamar a initparser en CocaComponent 
 
  }

  onAnalysisModeChange(event: any) {
    this.analysisService.changeAnalysisMode(event.target.value);
    this.resetTimer()
  }

  onTargetCEFRChange(event: any) {
    this.analysisService.changeTargetCEFR(event.target.value);
    this.resetTimer()
  }

  onExcludeDigitsChange(event: any) {
    this.analysisService.changeExcludeDigits(event.checked);
    this.resetTimer()
  }

  onUseKnownWordsChange(event: any) {
    this.analysisService.changeUseKnownWords(event.checked);
    this.resetTimer()
  }

  onSplitCharacterChange(event: any) {
    this.analysisService.changeSplitCharacter(event.target.value);
    this.resetTimer()
  }


updateJSON() {
  this.jsonValues = { 
    englishType: this.englishType, 
    textmode: this.analysisMode, 
    target: this.targetCEFR, 
    delimiter: this.splitCharacter, 
    excludeDigits: this.excludeDigits, 
    useKnownWords: this.useKnownWords,
    split: "1" ,// por ahora se deja en default en 1 y posiblemente se quede así
    wordlist: this.wordlistselect,
    matchPrhases: this.proyectoService.getdata()?.config_json?.matchPrhases ?? false,
  }; 
  
}


}
